import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { NavigationService } from 'src/app/services/navigation.service';
import { Location   } from '@angular/common';
import * as moment from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter'; 
import {default as _rollupMoment, Moment} from 'moment';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

@Component({
  selector: 'app-prefered-communication',
  templateUrl: './prefered-communication.component.html',
  styleUrls: ['./prefered-communication.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
  ],
})
export class PreferedCommunicationComponent implements OnInit {

  toShow = false;
  title: string = "Do you allow us to communicate to you via SMS ?";
  preferedCommmunicationForm: FormGroup;
  ConfirmationDateForm: FormGroup
  optionChossedByUser: string;
  @ViewChild('dateOfBirth') dateOfBirthPicker: MatDatepicker<Date>;
  @ViewChild('startDate') startDatePicker: MatDatepicker<Date>;
  CrntContentToDisplay: string = '';
  startDate = new FormControl(moment());
  date = new FormControl(moment());
  isShowPreferedCommunication: boolean = false
  isShowInCompleteProfile: boolean = false;
  isShowExistingOrders: boolean = false
  isShowCompleteVumatelOrder: boolean = false;
  isShowConfirmationDate: boolean = false;
  isShowFrogFootLinkStatus: boolean = false;
  statusItem: any;
  displayCurrentStepName: string;
  displayCurrentDescription: string;
  displayCurrentWorkflowName: string;
  displayOriginalEstimatedLiveDate: string;
  displayCurrentEstimatedLiveDate: string;
  selectedDate : any

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    // private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public popupdata: any,
    public dialogRef: MatDialogRef<PreferedCommunicationComponent>,
    private location: Location,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private navigate: NavigationService,
    private dialog: MatDialog,
  ) { 
    
    console.log('****** inside line 52'); 
  }

  ngOnInit(): void {
    console.log('****** inside line 52');

    if (this.popupdata != null) {
      if (this.popupdata.displayPanel) {
        this.CrntContentToDisplay = this.popupdata.displayPanel;
        console.log('this.CrntContentToDisplay :- ', this.CrntContentToDisplay);
        console.log('default date: ', this.startDate.value);
        
        if (this.CrntContentToDisplay === 'ExistingOrders') {
          this.isShowPreferedCommunication = false;
          this.isShowInCompleteProfile = false;
          this.isShowExistingOrders = true;
          this.isShowCompleteVumatelOrder = false;
          this.isShowConfirmationDate = false;
          this.isShowFrogFootLinkStatus = false;
        }
        else if (this.CrntContentToDisplay === 'PreferedCommunication') {
          this.isShowPreferedCommunication = true;
          this.isShowInCompleteProfile = false;
          this.isShowExistingOrders = false;
          this.isShowCompleteVumatelOrder = false;
          this.isShowConfirmationDate = false;
          this.isShowFrogFootLinkStatus = false;
        }
        else if (this.CrntContentToDisplay === 'CompleteProfile') {
          this.isShowPreferedCommunication = false;
          this.isShowInCompleteProfile = true;
          this.isShowExistingOrders = false;
          this.isShowCompleteVumatelOrder = false;
          this.isShowConfirmationDate = false;
          this.isShowFrogFootLinkStatus = false;
        }
        else if (this.CrntContentToDisplay === 'CompleteVumatelOrder') {
          this.isShowPreferedCommunication = false;
          this.isShowInCompleteProfile = false;
          this.isShowExistingOrders = false;
          this.isShowCompleteVumatelOrder = true;
          this.isShowConfirmationDate = false;
          this.isShowFrogFootLinkStatus = false;
        }
        else if (this.CrntContentToDisplay === 'ConfirmationDate') {
          this.isShowPreferedCommunication = false;
          this.isShowInCompleteProfile = false;
          this.isShowExistingOrders = false;
          this.isShowCompleteVumatelOrder = false;
          this.isShowConfirmationDate = true;
          this.isShowFrogFootLinkStatus = false;
        }
        else if (this.CrntContentToDisplay === 'FrogFootLinkStatus') {
          this.isShowPreferedCommunication = false;
          this.isShowInCompleteProfile = false;
          this.isShowExistingOrders = false;
          this.isShowCompleteVumatelOrder = false;
          this.isShowConfirmationDate = false;
          this.isShowFrogFootLinkStatus = true;
          this.statusItem = this.popupdata.statusItem;

          this.displayCurrentStepName = this.statusItem.currentStepName ? this.statusItem.currentStepName : 'Not Specified';
          this.displayCurrentDescription = this.statusItem.currentDescription ? this.statusItem.currentDescription : 'Not Specified';
          this.displayCurrentWorkflowName = this.statusItem.currentWorkflowName ? this.statusItem.currentWorkflowName : 'Not Specified';
          this.displayOriginalEstimatedLiveDate = this.statusItem.originalEstimatedLiveDate ? this.statusItem.originalEstimatedLiveDate : 'Not Specified';
          this.displayCurrentEstimatedLiveDate = this.statusItem.currentEstimatedLiveDate ? this.statusItem.currentEstimatedLiveDate : 'Not Specified';
        }
        else if (this.CrntContentToDisplay === 'FrogFootLinkStatus') {
          this.isShowPreferedCommunication = false;
          this.isShowInCompleteProfile = false;
          this.isShowExistingOrders = false;
          this.isShowCompleteVumatelOrder = false;
          this.isShowConfirmationDate = false;
          this.isShowFrogFootLinkStatus = true;
          this.statusItem = this.popupdata.statusItem;

          this.displayCurrentStepName = this.statusItem.currentStepName ? this.statusItem.currentStepName : 'Not Specified';
          this.displayCurrentDescription = this.statusItem.currentDescription ? this.statusItem.currentDescription : 'Not Specified';
          this.displayCurrentWorkflowName = this.statusItem.currentWorkflowName ? this.statusItem.currentWorkflowName : 'Not Specified';
          this.displayOriginalEstimatedLiveDate = this.statusItem.originalEstimatedLiveDate ? this.statusItem.originalEstimatedLiveDate : 'Not Specified';
          this.displayCurrentEstimatedLiveDate = this.statusItem.currentEstimatedLiveDate ? this.statusItem.currentEstimatedLiveDate : 'Not Specified';
        }
        else {
          this.isShowPreferedCommunication = false;
          this.isShowInCompleteProfile = false;
          this.isShowExistingOrders = false;
          this.isShowCompleteVumatelOrder = false;
          this.isShowConfirmationDate = false;
          this.isShowFrogFootLinkStatus = false;
        }
      }
    }
    this.initializeValidators();
  }


  handleSelectTitleClickEvent(option: string) {
    this.toShow = true;
    this.optionChossedByUser = option;
    if (option == '2') {
      this.title = "Do you allow us to communicate to you via SMS ?";
    } else if (option == '3') {
      this.title = "Do you allow us to communicate to you via WhatsApp ?";
    }
  }

  initializeValidators() {
    if (this.CrntContentToDisplay === 'PreferedCommunication') {
      this.preferedCommmunicationForm = this.fb.group({
        preferedType: [''],
        dateofbirth: ['', [Validators.required]]
      });
    }
    else if (this.CrntContentToDisplay === 'ConfirmationDate') {
      this.ConfirmationDateForm = this.fb.group({
        startDate: new FormControl(moment(), [
          Validators.required,
        ])
      });
    }
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value ?? moment();
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    console.log('##############  normalizedMonthAndYear', normalizedMonthAndYear);
    console.log('*&*&*&*&*&*&*&* ctrlValue : ', ctrlValue);
    
    this.selectedDate = ctrlValue;
    this.ConfirmationDateForm.controls['startDate'].setValue(ctrlValue);
    datepicker.close();
  }
  saveCustomerRequest() {
    this.dialogRef.close(this.optionChossedByUser);
  }
  close() {
    this.dialogRef.close();
  }
  saveExistingOrders(option: string) {
    this.dialogRef.close(option);
  }
  validateFormControl() {
    Object.keys(this.preferedCommmunicationForm.controls).forEach(field => {
      const control = this.preferedCommmunicationForm.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
  openDatePicker() {
    this.dateOfBirthPicker.open();
  }
  
  
  FnstartDatePicker() {
    this.startDatePicker.open();
  }

  onApply() {
    if (this.ConfirmationDateForm.valid) {
      this.dialogRef.close(this.selectedDate);
    }
    else {
      Object.keys(this.ConfirmationDateForm.controls).forEach(field => {
        const control = this.ConfirmationDateForm.get(field);
        if (control instanceof FormControl) {
          control.markAsTouched({
            onlySelf: true
          });
        }
      })
    }
  }
}
